module.exports = __webpack_public_path__ + "img/jwgl-pk-znfb.c1d50ed6.png";